var $8460600098fbe4ad$exports = {};
var $8460600098fbe4ad$var$faq = document.getElementsByClassName('faq-page');
function $8460600098fbe4ad$var$closeOthers(j) {
    for(let k = 0; k < $8460600098fbe4ad$var$faq.length; k++)if (k !== j) {
        let body = $8460600098fbe4ad$var$faq[k].lastElementChild;
        if (body.style.maxHeight) {
            body.style.maxHeight = null;
            const element = $8460600098fbe4ad$var$faq[k].children;
            element[1].classList.toggle('active');
        }
    }
}
for(let i = 0; i < $8460600098fbe4ad$var$faq.length; i++)$8460600098fbe4ad$var$faq[i].addEventListener('click', function() {
    const element = this.children;
    element[1].classList.toggle('active');
    var body = this.lastElementChild;
    if (body.style.maxHeight) body.style.maxHeight = null;
    else {
        body.style.maxHeight = body.scrollHeight + 'px';
        $8460600098fbe4ad$var$closeOthers(i);
    }
// for (j = 0; j < faq.length; j++) {
//   if (j !== i) {
//     body.style.maxHeight = null;
//   }
// }
});


//# sourceMappingURL=en-run.b72a3b33.js.map
